import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { Urls } from "../../../src/app/utils/urls";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class CustomerDataService {
    constructor(private dataProvider: DataService) {
    }

    async GetPostCodeDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetPostCodeDropdown).toPromise();
    }
}